export const slotsLeftThisMonth = (totalSlots = 3) => {
  const now = new Date();
  const dayOfMonth = now.getDate();
  const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const elapsedRatio = dayOfMonth / daysInMonth;

  if (elapsedRatio >= 0.85) return 1;
  if (elapsedRatio >= 0.6) return Math.max(1, totalSlots - 2);
  if (elapsedRatio >= 0.3) return Math.max(1, totalSlots - 1);
  return totalSlots;
};
